export const multipartyReferences = {
  heading: 'Next steps',
  description: 'Check out the page below to start integrating.',
  data: [
    {
      image:
        'https://www.paypalobjects.com/ppdevdocs/multipartyimages/document.png',
      tag: '',
      heading: 'Get started',
      description: 'See how to integrate with us at a glance.',
      link: 'https://developer.paypal.com/docs/multiparty/get-started/',
    },
  ],
}
